<div class="vs-section-content has-outline-menu" *ngFor="let detail of itemsCoreData; let i = index"
     [ngClass]="{'disabled-vs-content': detail['status'] === 'Desactivado'}">
  <div class="vs-crud-menu">
    <button *ngIf="enableEdit" type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Editar item"
            (click)="sendItemEdit(detail)">
      <mat-icon>edit</mat-icon>
    </button>
    <button *ngIf="enableDelete" type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Eliminar item"
            (click)="sendItemDelete(detail)">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
  <div *ngIf="!isNewlifetimeRent" class="content vs-image-text" [ngClass]="{'no-img': (!detail.img && !showPlaceHolder) || (i === 0 && hasIntro)}">
    <img
      *ngIf="detail.img || showPlaceHolder"
      class="img-fluid"
      [src]="detail.img || 'assets/images/img-placeholder.png'"
      [alt]="'img-info' + detail.id"
      onerror="this.onerror = null; this.src = 'assets/images/img-placeholder.png'">
              
    <p>{{detail.name || detail['title']}}</p>
    <p *ngIf="detail['subTitle']">{{detail['subTitle']}}</p>
    <p *ngIf="hasLink"><b>Link: </b> {{detail.img}}</p>
  </div>
  <div *ngIf="isNewlifetimeRent" class="content" [ngClass]="{'no-img': (!detail.img && !showPlaceHolder) || (i === 0 && hasIntro)}">
    <div class="d-flex">
    <img
        *ngIf="detail.img || showPlaceHolder"
        class="img-fluid"
        [src]="detail.img || 'assets/images/img-placeholder.png'"
        [alt]="'img-info' + detail.id"
        onerror="this.onerror = null; this.src = 'assets/images/img-placeholder.png'">           

      <p class="my-auto p-newLifetimeRent">{{detail.name || detail['title']}}</p>
    </div>
    <p [innerHTML]="detail['subTitle']" *ngIf="detail['subTitle']"></p>
  </div>
</div>
<div class="w-100 text-center" *ngIf="!itemsCoreData.length">
  <h2 class="mb-4">No existen datos habilitados</h2>
</div>
